import FieldWithType from 'routes/ReferralForm/FormView/components/FieldWithType/FieldWithType';

export default FieldWithType;
